import { normalizeCustomerName } from './customerContext';

const VALID_CUSTOMER_ACCOUNT_ROLES = new Set(['OWNER', 'MANAGER']);

function normalizeAccountRole(value) {
  if (value == null) return null;
  const normalized = String(value).trim().toUpperCase();
  return VALID_CUSTOMER_ACCOUNT_ROLES.has(normalized) ? normalized : null;
}

function cleanIdentity(value) {
  if (value == null) return '';
  const text = String(value).trim();
  if (!text) return '';
  const lowered = text.toLowerCase();
  return lowered === 'null' || lowered === 'undefined' ? '' : text;
}

function withCustomerAccountCapabilities(session, payload) {
  const role = String(session?.role || '').toLowerCase();
  const hasCustomer = session?.customerId != null;
  const customerAccountRole = normalizeAccountRole(payload?.customerAccountRole);

  if (role !== 'customer' || !hasCustomer || !customerAccountRole) {
    return {
      ...session,
      customerAccountRole: null,
      canManageBilling: false,
      canManageCustomerUsers: false,
    };
  }

  return {
    ...session,
    customerAccountRole,
    canManageBilling: payload?.canManageBilling === true,
    canManageCustomerUsers: customerAccountRole === 'OWNER' && payload?.canManageCustomerUsers === true,
  };
}

export function buildAuthProviderSession(payload) {
  const role = payload?.role ?? null;
  const userId = payload?.userId ?? null;
  const customerName = normalizeCustomerName(payload?.customerName ?? payload?.customer_name);
  const name = cleanIdentity(payload?.name);
  const email = cleanIdentity(payload?.email);

  return withCustomerAccountCapabilities({
    userId: userId == null ? null : Number(userId),
    role: role == null ? null : String(role),
    customerId: payload?.customerId == null ? null : Number(payload.customerId),
    ...(name ? { name } : {}),
    ...(email ? { email } : {}),
    ...(customerName ? { customerName } : {}),
  }, payload);
}

export function buildWhoAmISession(payload) {
  const userId = payload?.userId ?? payload?.id ?? null;
  const roleRaw = payload?.role ?? null;
  const role = String(roleRaw || '').toLowerCase();
  const isTechOrOperator = role === 'technician' || role === 'operator';
  const customerName = normalizeCustomerName(payload?.customerName ?? payload?.customer_name);
  const name = cleanIdentity(payload?.name);
  const email = cleanIdentity(payload?.email);

  return withCustomerAccountCapabilities({
    userId,
    role: roleRaw ?? null,
    customerId: isTechOrOperator ? null : (payload?.customerId ?? null),
    ...(name ? { name } : {}),
    ...(email ? { email } : {}),
    ...(customerName ? { customerName } : {}),
  }, payload);
}
